import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Scroll to top when pathname changes
    const scrollToTop = () => {
      // Try smooth scrolling first, fallback to instant scroll
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      } else {
        // Fallback for older browsers
        window.scrollTo(0, 0)
      }
    }

    // Small delay to ensure the new page has loaded
    const timer = setTimeout(scrollToTop, 100)
    
    return () => clearTimeout(timer)
  }, [pathname])

  return null
} 